<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <h1 class="header">
      {{ "bigTicketPurpose.header" | translate }}
    </h1>
    <app-card
      [title]="'bigTicketPurpose.title' | translate"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content class="big-purpose-margin">

        <ng-template [ngTemplateOutlet]="bigPurposeBlock"></ng-template>

        <div actions class="navigationButtons">
          <button
            (click)="handleContinueButtonClick()"
            mat-flat-button
            color="primary"
          >
            {{ "global.continueButton" | translate }}
          </button>
        </div>

      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <ng-template [ngTemplateOutlet]="bigPurposeBlock"></ng-template>
    </div>
  </ng-template>
</div>

<ng-template #bigPurposeBlock>
  <form [formGroup]="purposeForm">
    <div left-content class="content-container">
      <app-textarea
        [label]="!isSummary ? 'bigTicketPurpose.reasonDescription' : 'summary.bigTicket.reasonDescriptionTitle'"
        [control]="reasonDesc"
        (blurEvent)="reasonDescriptionUpdate()"
      ></app-textarea>

      <app-file-uploader
        [label]="!isSummary ? 'bigTicketPurpose.fileUploadLabel' : 'summary.bigTicket.filesTitle'"
        [control]="otherSecuritiesFiles"
        [controlName]="'otherSecuritiesFiles'"
        [applicationId]="applicationId"
        [uploaderName]="assetName.OTHER"
        [isSummary]="isSummary"
      ></app-file-uploader>

      <app-infobox 
        *ngIf="!isSummary"
        [title]="'bigTicketPurpose.infobox.title' | translate"
        [content]="'bigTicketPurpose.infobox.content' | translate"
      ></app-infobox>
    </div>
  </form>
</ng-template>
